<template>
  <el-button type="primary" :disabled="!items.length" @click="onMakePay">
    Сформировать платежи на оплату
  </el-button>
</template>

<script>
import { RepositoryFactory } from '@/api/RepositoryFactory'

const Payments = RepositoryFactory.get('payments')

export default {
  name: 'MakePymentsBtn',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    onMakePay() {
      const sum = this.getRound(
        this.items.reduce((a, b) => a + b.payment_left, 0),
      )

      if (parseFloat(sum) > 0) {
        this.$confirm(
          `Осталось оплатить ${sum} р.\n Вы хотите создать платежу на указанную сумму?`,
          '',
          {
            confirmButtonText: 'Да',
            cancelButtonText: 'Отмена',
            type: 'warning',
          },
        )
          .then(() => this.makePayments(this.items))
          .catch(() => {})
      } else {
        this.$message.info('Сумма остатка по платежам равна 0')
      }
    },
    makePayments(items) {
      items.map(item => {
        const { id, payment_left } = item

        if (payment_left) {
          const payment = {
            response_id: id,
            sum: payment_left,
            payment_number: null,
          }

          Payments.create(payment)
            .then(res => {
              if (res.status === 201) {
                this.$store.dispatch('responses/fetchFlight', id)
              }
            })
            .catch(err => this.errHandler(err))
        }
      })
    },
  },
}
</script>
